const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (err) => reject(err));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = src;
  });

/**
 * Renders the selected crop area to a File, so the saved image is exactly
 * what the user framed inside the crop window.
 */
export const getCroppedFile = async (imageSrc, cropPixels, { fileName = 'image.jpg', mimeType = 'image/jpeg', maxDimension = 2000 } = {}) => {
  const image = await loadImage(imageSrc);

  const cropWidth = Math.max(1, Math.round(cropPixels.width));
  const cropHeight = Math.max(1, Math.round(cropPixels.height));

  const scale = Math.min(1, maxDimension / Math.max(cropWidth, cropHeight));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(cropWidth * scale);
  canvas.height = Math.round(cropHeight * scale);

  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(
    image,
    Math.round(cropPixels.x),
    Math.round(cropPixels.y),
    cropWidth,
    cropHeight,
    0,
    0,
    canvas.width,
    canvas.height
  );

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, mimeType, 0.92));
  const extension = mimeType === 'image/png' ? 'png' : 'jpg';
  const safeName = `${fileName.replace(/\.[^.]+$/, '') || 'image'}.${extension}`;
  return new File([blob], safeName, { type: mimeType, lastModified: Date.now() });
};

export const readFileAsDataURL = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
